import React, { useState } from 'react';
import * as ReactGA from 'react-ga';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Header.css';
import c from 'classnames';
import {
  selectMenuActive,
  selectUploadFormActive,
  changeMenuAction,
  changeUploadFormAction,
} from '../../ducks';
import { documentSetCookie } from '../../cookie';
import { ClickElement } from '../form';
import { Search } from '../search';
import { adBreakPoint } from '../../lib/helpers';
import { HEADER } from '../../lib/labels';
import { AuthElement } from '../auth';
import { useDispatch, useSelector} from 'react-redux';
import logoImg from './dumpert-logo.svg';
import { useCurrentBreakPoint, useShowingOnScroll, currentActiveMenuLocation } from '../commons';

export const Header = ({ modalActive }) => {
  const showing = useShowingOnScroll();
  const currentBreakPoint = useCurrentBreakPoint();
  const [searchFieldActive, setSearchFieldActive] = useState(false);
  const menuShowing = useSelector(selectMenuActive);
  const uploadFormShowing = useSelector(selectUploadFormActive);
  const dispatch = useDispatch();
  const history = useHistory();
  const activeMenuItem = currentActiveMenuLocation();

  const showMenuLabel = label =>
    ['XL', 'L'].includes(adBreakPoint(currentBreakPoint)) && (<span>{label}</span>);

  return(
    <header className={c({ [styles.hide]: (!showing && !modalActive) })}>
      <div className={c('container', styles.header_container)}>
        <Link to="/" className={styles.logo} onClick={() => {
          documentSetCookie('list', 'latest');
          ReactGA.event({
            category: 'Links',
            action: 'Logo',
            label: 'LogoClick',
          });
        }}>
          <img
            // eslint-disable-next-line
            src={logoImg}
            alt="Dumpert logo"
          />
        </Link>
        <div className={styles.header_navigation}>
          {/* Show latest and topper in header > 640px */}
          {!(['XS'].includes(adBreakPoint(currentBreakPoint))) && (
            <>
              <ClickElement
                testId = "latest"
                ElementType={Link}
                secondary
                active={activeMenuItem === 'nieuw'}
                text={HEADER.ITEM.NEW}
                to='/latest'
                onClick={() => documentSetCookie('list', 'latest')}
              />
              <ClickElement
                testId = "toppers"
                ElementType={Link}
                secondary
                text={HEADER.ITEM.TOPPERS}
                to='/toppers'
                active={activeMenuItem === 'toppers'}
                onClick={() => documentSetCookie('list', 'toppers')}
              />
            </>
          )}
          {/* Show DumpertTV > 970px */}
          {!(['XS', 'S'].includes(adBreakPoint(currentBreakPoint))) && (
            <ClickElement
              testId = "dumperttv"
              ElementType={Link}
              secondary
              to='/tag/dumperttv'
              active={activeMenuItem === 'dumperttv'}
              text={(
                <>
                  {HEADER.ITEM.BRAND}
                  <span style={{ 'color': '#6c2', 'display': 'inline-block', 'marginLeft': '0px' }}>
                    {HEADER.ITEM.TV}
                  </span>
                </>
              )}
              onClick={() => documentSetCookie('list', 'dumperttv')}
            />
          )}
          {/* Show Searchbar > 640px */}
          {!(['XS'].includes(adBreakPoint(currentBreakPoint))) && (
            <>
              {!(['XS', 'S'].includes(adBreakPoint(currentBreakPoint))) && (
                <ClickElement
                  testId = "search"
                  tertiary={searchFieldActive}
                  secondary={!searchFieldActive}
                  ElementType='button'
                  text={<>
                    {searchFieldActive && <FontAwesomeIcon icon="times" size="lg" />}
                    {!searchFieldActive && (<>
                      <FontAwesomeIcon icon="search" size="lg" />
                      {showMenuLabel(HEADER.ITEM.SEARCH)}
                    </>)}
                  </>}
                  onClick={() => setSearchFieldActive(!searchFieldActive)}
                />
              )}
              <div className={c(
                styles.searchfield,
                {
                  [styles.active]: searchFieldActive || (['S'].includes(adBreakPoint(currentBreakPoint))),
                  [styles.small]: (['S'].includes(adBreakPoint(currentBreakPoint))),
                },
                'search_field')}>
                <Search
                  placeholder={HEADER.SEARCH.PLACEHOLDER}
                  active={searchFieldActive}
                  onSubmit={x => {
                    history.push(`/zoek/${x}`);
                    ReactGA.event({
                      category: 'Other',
                      action: 'SearchAction',
                      label: x,
                    });
                  }} />
              </div>
            </>
          )}
          <ClickElement
            testId = "dump"
            primary
            ElementType='button'
            text={(<>
              {!(['XS', 'S'].includes(adBreakPoint(currentBreakPoint))) && (
                <FontAwesomeIcon icon="arrow-circle-up" size="lg" />
              )}
              <span>{HEADER.ITEM.DUMP}</span>
            </>)}
            onClick={() => dispatch(changeUploadFormAction(!uploadFormShowing))}
          />
          <AuthElement
            history={history}
            showLabel={['XL', 'L', 'M'].includes(adBreakPoint(currentBreakPoint))}
          />
          <ClickElement
            testId = "menu"
            secondary
            ElementType='button'
            text={(<>
              <FontAwesomeIcon icon="bars" size="lg" />
              {showMenuLabel(HEADER.ITEM.MENU)}
            </>)}
            onClick={() => dispatch(changeMenuAction(!menuShowing))}
          />
        </div>
      </div>
    </header>
  );
};
